<ion-footer [ngClass]="{'blue-footer': !isTermsAndPrivacy, 'white-footer': isTermsAndPrivacy}">
  <ion-toolbar [ngClass]="{'primary-toolbar': !isReference, 'reference-toolbar': isReference}">
  <ion-row>
    @if (showPrimaryButton) { 
      <ion-col>
        <ion-button shape="round" class="blue-button" [ngClass]="{'width-100': !isReference}" (click)="primaryButtonClick($event)" [disabled]="disablePrimaryButton">
          @if (showPrimaryButtonIcon) {
            <ion-icon [name]="primaryButtonIcon"></ion-icon>
          }
          <span>{{ primaryButtonText | translate }}</span>
        </ion-button>
      </ion-col>
    }
    @if (showSecondaryButton) {
      <ion-col>
        <ion-button shape="round" [ngClass]="{'blue-button': !isTermsAndPrivacy, 'white-button': isTermsAndPrivacy, 'reference-button': isReference, 'width-100': !isReference}" (click)="secondaryButtonClick($event)" [disabled]="disableSecondaryButton">
          @if (showSecondaryButtonIcon) {
            <ion-icon [name]="secondaryButtonIcon"></ion-icon>
          }
          <span>{{ secondaryButtonText | translate }}</span>
        </ion-button>
      </ion-col>
    }
  </ion-row>
</ion-toolbar>
</ion-footer>